// extracted by mini-css-extract-plugin
export default {"inputBox":"Inputs_inputBox__8vLT3","input":"Inputs_input__daMoZ","inputSuccess":"Inputs_inputSuccess__N0+gZ","errorText":"Inputs_errorText__MnX2X"};